import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BiPencil } from "react-icons/bi";
import { Users, GraduationCap, Info, Calendar, Trash } from "lucide-react";

import { ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"

// Suas importações originais
import TurmaAdd from "./TurmaAdd";

import { getDocumentoUnico, filtro, removerTurmaCompleta } from "../../../firebase/CRUD";
import BackButton from '../../layout/BackButton';
import { useAuth } from "../../../hooks/AuthContext";

// Importação do CSS isolado
import "./turmas.css";



export default function TurmasView() {
    const [turmaInfo, setTurmaInfo] = useState({});
    const [alunos, setAlunos] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [cadastramento, setCadastramento] = useState(false);
    
    const { id } = useParams();
    const { usuario } = useAuth();


    useEffect(() => {
        // Lógica original de chamadas ao Firebase mantida intacta
        getDocumentoUnico("turmas", id, setTurmaInfo, usuario.idEscola);
        filtro("alunos", "turma", "==", id, setAlunos, usuario.idEscola);
        filtro("professores", "turma", "==", id, setProfessores, usuario.idEscola);
    }, [id, usuario.idEscola]);

    const ativarCadastramento = () => setCadastramento(true);
    const desativarCadastramento = () => setCadastramento(false);
    const navigate = useNavigate()

    const FichaAlunos = ({aluno})=>{
        return(
            <div className="card-aluno" onClick={() => {
                navigate(`/alunos/${aluno.id}`,{state:aluno})
            }}>
                <div className="card-avatar">{aluno.nome[0]}</div>
                <div className="card-info">
                    <span className="card-nome">{aluno.nome}</span>
                </div>
                <ChevronRight className="card-arrow" size={20} />
            </div>
        )
    }
    const deletarCadastro = async ()=>{
        if(window.confirm("Após apagar, os dados desse registro não serão recuperados, deseja mesmo apagar?")){
            // CORREÇÃO: `deleteItem('turmas', ...)` sozinho apagava só o
            // documento da turma — a subcoleção `membros` embaixo dela
            // ficava órfã no Firestore (subcoleções não são apagadas
            // automaticamente junto com o documento pai).
            await removerTurmaCompleta(usuario.idEscola, turmaInfo.id)
            navigate(-1,{replace:true})
        }
    }
    return (
        <div className="turma-container">
            {/* --- CABEÇALHO IMERSIVO --- */}
            <div className="turma-header">
                <div className="top-actions">
                    <BackButton/>
                    {usuario.perfil === "adm" && <div style={{display:'flex', gap:'10px'}}>
                        <button className="icon-btn" onClick={ativarCadastramento} title="Editar Turma">
                            <BiPencil size={24} />
                        </button>
                        <button 
                            className="icon-btn"
                            onClick={deletarCadastro}
                            title="Deletar turma"
                        >
                            <Trash size={24}/>
                        </button>
                    </div>}
                </div>
                
                <div className="turma-header-info">
                    <div className="turma-avatar">
                        <Users size={36} strokeWidth={2} />
                    </div>
                    <h2 className="turma-nome">
                        {turmaInfo.nome ? turmaInfo.nome : 'A carregar...'}
                    </h2>
                    <span className="badge-turma">Turma da EBD</span>
                </div>
            </div>

            {/* --- CONTEÚDO PRINCIPAL --- */}
            <div className="turma-content">
                
                {/* Modal de Edição original */}
                {cadastramento && <TurmaAdd cadastramento={desativarCadastramento} edit={turmaInfo} />}

                {/* CARD 1: VISÃO GERAL (Detalhes da Turma) */}
                <div className="data-card">
                    <h3 className="card-title">Detalhes da Turma</h3>
                    
                    <div className="info-grid">
                        {/* Data de Criação (Opcional, se existir no seu banco) */}
                        {turmaInfo.dataCriacao && (
                            <div className="info-box">
                                <div className="info-icon-wrapper"><Calendar size={20} /></div>
                                <div className="info-text">
                                    <label>Data de Criação</label>
                                    <span>{turmaInfo.dataCriacao}</span>
                                </div>
                            </div>
                        )}

                        <div className="info-box">
                            <div className="info-icon-wrapper"><GraduationCap size={20} /></div>
                            <div className="info-text">
                                <label>Professor(a)s</label>
                                <span>
                                    {professores.length > 0 
                                        ? professores.map(p => p.nome).join(', ') 
                                        : 'Nenhum professor associado'}
                                </span>
                            </div>
                        </div>

                        <div className="info-box">
                            <div className="info-icon-wrapper"><Users size={20} /></div>
                            <div className="info-text">
                                <label>Matriculados</label>
                                <span>{alunos.length}</span>
                            </div>
                        </div>
                    </div>

                    {turmaInfo.descricao && (
                        <div className="info-box info-box-full" style={{marginTop: '16px'}}>
                            <div className="info-icon-wrapper"><Info size={20} /></div>
                            <div className="info-text">
                                <label>Descrição</label>
                                <span>{turmaInfo.descricao}</span>
                            </div>
                        </div>
                    )}
                </div>

                {/* CARD 2: LISTA DE ALUNOS */}
                <div className="alunos-section">
                    <h3 className="section-title">Alunos</h3>
                    
                    <div className="lista-alunos">
                        {alunos.length > 0 ? (
                            alunos.map((item, index) => (
                                <FichaAlunos key={item.id} aluno={item}/>
                            ))
                        ) : (
                            <p style={{textAlign: 'center', color: '#64748b'}}>
                                {turmaInfo.nome ? "Nenhum aluno matriculado nesta turma ainda." : "A carregar alunos..."}
                            </p>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
}